import React from 'react';

import styles from './Terms.module.css';

const terms = () => (
    <>
        <div className={styles["TermsDescription"]}>
            <h1>Terms & Conditions</h1>
            <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deserunt modi repellat consectetur omnis enim? Itaque doloribus ea distinctio quasi, ad modi tempora at nobis voluptas omnis deleniti impedit voluptate in quia iusto quae dolor pariatur eligendi necessitatibus numquam voluptatibus optio, aperiam non? Earum assumenda iure, veniam pariatur consequatur esse tempora.
            </p>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam reiciendis labore, mollitia consequatur debitis fugit eum consequuntur in neque expedita inventore ullam molestias facilis ipsum suscipit? Suscipit saepe ipsam assumenda accusamus ratione? Sapiente tempore saepe nobis adipisci dolor sint tempora, dicta tenetur molestiae ipsam assumenda maiores maxime consequuntur, quisquam veniam.
            </p>
        </div>
    </>
        );
        
export default terms;